var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransaction(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 0v61l-30 30h-452l-30-30v-61zm0 0",
    fill: "#9bfcff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m512 0v61l-30 30h-226v-91zm0 0",
    fill: "#25d9f8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m512 61v90l-30 30h-452l-30-30v-90zm0 0",
    fill: "#61729b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m512 61v90l-30 30h-226v-120zm0 0",
    fill: "#47568c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m0 151h512v210h-512zm0 0",
    fill: "#9bfcff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m256 151h256v210h-256zm0 0",
    fill: "#25d9f8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m181 301h-121v-90h121zm0 0",
    fill: "#ffda2d"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m211 211h241v30h-241zm0 0",
    fill: "#4bb9ec"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m331 271h121v30h-121zm0 0",
    fill: "#0095ff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m316 422-60 90-60-90h30v-121h60v121zm0 0",
    fill: "#7fe881"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m286 422h30l-60 90v-211h30zm0 0",
    fill: "#5bc980"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m256 211h196v30h-196zm0 0",
    fill: "#0095ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransaction);
export default __webpack_public_path__ + "static/media/transaction.a85fd08f.svg";
export { ForwardRef as ReactComponent };